import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap'

import { useDispatch } from 'react-redux'
import { AnswerStateEnum } from 'enum/answer-state.enum'
import MandatoryQuestion from 'components/ui/mandatory-question/MandatoryQuestion'
import { breakLinesFix } from 'helpers/others.helper'
import { sanitizeHtml } from 'helpers/sanitizeHtml'
import * as fromLessonActions from 'store/actions/lessons.action'
import answerOpenEndedCreate from 'api/answers/open-endeds/Create'
import { QuestionTypeEnum } from 'enum'
import { useLesson } from 'contexts'
import GetStateIcon from '../AnswerStateIcon/AnswerStateIcon'
import styles from './OpenEnded.module.scss'

interface IOpenEnded {
  data: any
  instanceId: number
  refArray: any
  canEdit: boolean
  lessonIndex: number
  questionIndex: number
}

const OpenEnded: React.FC<IOpenEnded> = ({
  data,
  instanceId,
  refArray,
  canEdit,
  lessonIndex,
  questionIndex,
}) => {
  const [value, setValue] = useState('')
  const [answerState, setStateIcon] = useState(0)
  const dispatch = useDispatch()
  const { submit } = useLesson()

  useEffect(() => {
    const {
      answer: { content },
    } = data
    setValue(content || '')
  }, [data])

  const handleChange = (event: any) => {
    setStateIcon(AnswerStateEnum.Typing)
    setValue(event.target.value)
  }

  const handleSave = async () => {
    if (canEdit) {
      setStateIcon(AnswerStateEnum.Sending)
      try {
        const answer = await answerOpenEndedCreate({
          content: value,
          answer_attributes: {
            block_instance_id: instanceId,
            question_id: data.id,
          },
        })
        dispatch(
          fromLessonActions.Actions.lessonsSurveySetQuestionResponse({
            index: lessonIndex,
            questionIndex,
            value: {
              type: QuestionTypeEnum.openEnded,
              answer: {
                id: answer.id,
                content: value,
                createdAt: answer.createdAt,
                updatedAt: answer.updatedAt,
              },
            },
          })
        )
      } finally {
        setStateIcon(AnswerStateEnum.Success)
      }
    }
  }

  useEffect(() => {
    let timer: any
    if (answerState !== 0) {
      timer = setTimeout(() => {
        handleSave()
      }, 1000)
    }
    return () => clearTimeout(timer)
    // eslint-disable-next-line
  }, [value])

  return (
    <div id={'openEnded'} ref={refArray}>
      <div className="mb-2">
        <div
          className={styles.questionTitle}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(breakLinesFix(data.name)),
          }}
        />
        <Form.Control
          as="textarea"
          rows={5}
          id={data.id}
          name={data.id}
          className={`mt-2 mb-2 ${styles.text}`}
          value={value}
          disabled={!canEdit}
          onChange={handleChange}
        />
      </div>
      <div className={'mb-2 d-flex justify-content-between'}>
        <MandatoryQuestion show={submit && data.mandatory} />
        <GetStateIcon state={answerState} />
      </div>
    </div>
  )
}

export default OpenEnded
